/* Back-in-stock capture on the 2026 PDP.

   The row hosts the Klaviyo embed. Two jobs here:

   1. keep the variant details on the wrapper in step with what is selected,
      since the shopper can pick a different sold-out size without a reload
   2. send the product and variant context to Klaviyo when the form is
      submitted, so the back-in-stock alert and the profile both know which
      variant was asked for

   Klaviyo announces its own lifecycle on the window as `klaviyoForms`, which is
   the supported hook -- binding to the injected submit button directly would
   break whenever Klaviyo re-renders the form. */
(function () {
  const WRAPPER = '[data-pdp2026-notify]';

  function wrapper() {
    return document.querySelector(WRAPPER);
  }

  /* ---- keep the variant details current ---- */
  function variantFromDom() {
    const root = document.querySelector('.pdp2026-options');
    if (!root) return null;
    const script = root.querySelector('script[type="application/json"]');
    if (!script) return null;

    let data;
    try {
      data = JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
    if (!Array.isArray(data)) return null;

    const names = [];
    const chosen = {};
    root.querySelectorAll('input.pdp2026-option__input').forEach((input) => {
      if (names.indexOf(input.name) === -1) names.push(input.name);
      if (input.checked) chosen[input.name] = input.value;
    });
    const options = names.map((name) => chosen[name]);
    if (options.some((value) => value === undefined)) return null;

    return data.find((variant) =>
      variant.options.every((option, index) => options[index] === option)
    ) || null;
  }

  function syncVariant() {
    const el = wrapper();
    const variant = variantFromDom();
    if (!el || !variant) return;
    el.dataset.variantId = String(variant.id);
    el.dataset.variantTitle = variant.title || '';
    el.dataset.variantSku = variant.sku || '';
    // Shopify prices are in cents.
    el.dataset.variantPrice = (Number(variant.price) / 100).toFixed(2);
  }

  document.addEventListener('change', (event) => {
    if (event.target.matches && event.target.matches('.pdp2026-option__input')) {
      setTimeout(syncVariant, 0);
    }
  });

  /* ---- report the request to Klaviyo ---- */
  function report() {
    const el = wrapper();
    if (!el || !window.klaviyo) return;

    const productTitle = el.dataset.productTitle || '';
    const productUrl = el.dataset.productUrl || '';
    const variantId = el.dataset.variantId || '';
    const state = {
      title: el.dataset.variantTitle || '',
      sku: el.dataset.variantSku || '',
      price: el.dataset.variantPrice || '',
    };

    window.klaviyo.push(['track', 'Back in Stock Requested', {
      ProductTitle: productTitle,
      ProductURL: productUrl,
      VariantID: variantId,
      VariantTitle: state.title,
      VariantSKU: state.sku,
      Price: state.price,
      SourceURL: window.location.href,
    }]);

    window.klaviyo.push(['identify', {
      'Last OOS Product': productTitle,
      'Last OOS Variant': state.title,
      'Last OOS Variant ID': variantId,
      'Last OOS URL': window.location.href,
    }]);
  }

  /* ---- which state the embed is showing ----

     Klaviyo swaps the whole form between two versions in place: the capture
     form, and the "thanks for signing up" message. Both land in this same
     wrapper, so the frame the design puts around the input and button -- the
     border and the fixed 64px height -- was drawn around the message too,
     boxing it in and clipping its first line.

     The state is read from the markup rather than from Klaviyo's
     form-version-cid-N classes: those numbers belong to a particular saved
     configuration and change when the form is edited. An email field is what
     actually makes this a form. */
  function syncState() {
    const el = wrapper();
    if (!el) return;
    const isForm = !!el.querySelector('input[type="email"]');
    el.classList.toggle('pdp2026-notify--form', isForm);
    el.classList.toggle('pdp2026-notify--message', !isForm && el.children.length > 0);
  }

  /* Klaviyo renders late and replaces the form on submit, so watch rather than
     racing it. */
  function watchState() {
    const el = wrapper();
    if (!el) return;
    syncState();
    new MutationObserver(syncState).observe(el, { childList: true, subtree: true });
  }

  window.addEventListener('klaviyoForms', (event) => {
    const detail = event.detail || {};
    // Only the form inside our row, and only once it has actually been sent.
    if (detail.type !== 'submit') return;
    const el = wrapper();
    if (!el || !el.querySelector('[class*="klaviyo-form-"]')) return;
    report();
  });

  function start() {
    syncVariant();
    watchState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.pdp2026SyncNotifyVariant = syncVariant;
})();
